import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryPersonnelContentSectionHeaderCls: string;
			heHubPulsarsDiscoveryPersonnelBoardCarouselInfoId: string;
		}
	},

	slug: string
}

class Personnel extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Personnel Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryPersonnelContentSectionHeaderCls || '', 'he_hub_pulsars_discovery_personnel', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryPersonnelBoardCarouselInfoId || '', 'he_hub_pulsars_discovery_personnel', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Personnel;